import { render } from "./StudyStatistics.vue?vue&type=template&id=2b9184f4&scoped=true"
import script from "./StudyStatistics.vue?vue&type=script&lang=js"
export * from "./StudyStatistics.vue?vue&type=script&lang=js"

import "./StudyStatistics.vue?vue&type=style&index=0&id=2b9184f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b9184f4"]])

export default __exports__